"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberShowType = void 0;
/**
 * 多维表数字属性显示类型
 */
var NumberShowType;
(function (NumberShowType) {
    NumberShowType["BAR"] = "bar";
    NumberShowType["RING"] = "ring";
    NumberShowType["LEVEL"] = "level";
})(NumberShowType = exports.NumberShowType || (exports.NumberShowType = {}));
